module.exports = __webpack_public_path__ + "img/contactus.eb430d30.png";